import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ImageCollection from "../../../../components/ImageCollection";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const ArtDirection = makeShortcode("ArtDirection");
const GifPlayer = makeShortcode("GifPlayer");
const Video = makeShortcode("Video");
const Aside = makeShortcode("Aside");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`IBM creates intelligent solutions and products predicated on finding patterns—in data, human behavior and the world around us. Understanding the rhythm of patterns helps us build tools that provide insight for our clients and our business. In keeping with this point of view, pattern plays a critical role in our architecture. As an element of interior design, it adds textural dimension to our space that references and reflects our identity.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Use case examples</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Pattern and the 2x Grid</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Pattern layouts and repeats</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Pattern form </AnchorLink>
  <AnchorLink mdxType="AnchorLink">Materiality</AnchorLink>
    </AnchorLinks>
    <h2>{`Use case examples`}</h2>
    <ImageCollection mdxType="ImageCollection">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABfREYmCQ//8QAGhAAAwEAAwAAAAAAAAAAAAAAAAECERITFP/aAAgBAQABBQL0TqqXPezBtnJn/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BiP/EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAECAQE/AbU//8QAGBABAAMBAAAAAAAAAAAAAAAAAQARIDH/2gAIAQEABj8CpJZOGP/EABkQAAMBAQEAAAAAAAAAAAAAAAABESExQf/aAAgBAQABPyGDsY5UMzvLoyI7FWNLWO/T/9oADAMBAAIAAwAAABBH/wD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPxCEP//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/ELW//8QAHBABAAIDAAMAAAAAAAAAAAAAAQARITFBYXHR/9oACAEBAAE/ECsmmxcdCAqYPqHcF4RY2vcLW5XlQ1fIr4k//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Ehningen, Germany",
            "title": "IBM Ehningen, Germany",
            "src": "/workplace-xg/static/85beea4be972cceabb2d5fbbb1b7fe72/2e753/ibm-ehningen-germany.jpg",
            "srcSet": ["/workplace-xg/static/85beea4be972cceabb2d5fbbb1b7fe72/69549/ibm-ehningen-germany.jpg 288w", "/workplace-xg/static/85beea4be972cceabb2d5fbbb1b7fe72/473e3/ibm-ehningen-germany.jpg 576w", "/workplace-xg/static/85beea4be972cceabb2d5fbbb1b7fe72/2e753/ibm-ehningen-germany.jpg 1152w", "/workplace-xg/static/85beea4be972cceabb2d5fbbb1b7fe72/74f4b/ibm-ehningen-germany.jpg 1728w", "/workplace-xg/static/85beea4be972cceabb2d5fbbb1b7fe72/f35b7/ibm-ehningen-germany.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Ehningen, Germany</Caption>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDAv/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABpn6wl0SMrZDaUJ//xAAdEAACAgIDAQAAAAAAAAAAAAABAwIRABITISIj/9oACAEBAAEFAmQjclC9axrPnzXAs7ERozzhFn//xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/AUaKf//EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAECAQE/AWP/xAAZEAACAwEAAAAAAAAAAAAAAAAQEQABEkH/2gAIAQEABj8Co6UYzyZQ/8QAHBABAAICAwEAAAAAAAAAAAAAAQARITFBUXFh/9oACAEBAAE/IdCM9TRYjqG/WYRaG/kDi77nklRxSpoEvmGiz//aAAwDAQACAAMAAAAQ9yAC/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxDQ4M//xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EENHP//EABwQAQADAQEAAwAAAAAAAAAAAAEAESExQVGBof/aAAgBAQABPxARBWppV6+TBGOIwFiQKhMKLvXP0j9u8ePYXDxolwQRqw79wXUQ+2F22/Cz/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Slat wall in collaboration area",
            "title": "Slat wall in collaboration area",
            "src": "/workplace-xg/static/277f47feab3ceed5ca73e9a1f52a5f86/968f2/slat-wall-in-collaboration-area.jpg",
            "srcSet": ["/workplace-xg/static/277f47feab3ceed5ca73e9a1f52a5f86/69549/slat-wall-in-collaboration-area.jpg 288w", "/workplace-xg/static/277f47feab3ceed5ca73e9a1f52a5f86/473e3/slat-wall-in-collaboration-area.jpg 576w", "/workplace-xg/static/277f47feab3ceed5ca73e9a1f52a5f86/968f2/slat-wall-in-collaboration-area.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Malmo, Sweden</Caption>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABu12o55qJf//EABsQAAICAwEAAAAAAAAAAAAAAAECAAMREiET/9oACAEBAAEFAnIWaCHhehXPliGvv//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAEDAQE/Aaf/xAAWEQEBAQAAAAAAAAAAAAAAAAARARD/2gAIAQIBAT8BoZ//xAAYEAADAQEAAAAAAAAAAAAAAAAAEBExAf/aAAgBAQAGPwI1W9NX/8QAGRABAQEBAQEAAAAAAAAAAAAAAQARMVFh/9oACAEBAAE/IWMewxsOhauD8jLtvRf/2gAMAwEAAgADAAAAEBPP/8QAFxEAAwEAAAAAAAAAAAAAAAAAARAhMf/aAAgBAwEBPxAVcX//xAAXEQADAQAAAAAAAAAAAAAAAAAQESEx/9oACAECAQE/EIlo/8QAGRABAQEBAQEAAAAAAAAAAAAAAREAIUFR/9oACAEBAAE/EAtleGZpkLwwiKh93KrBETE4GSdN2ULv/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "volumetric painted wood slat wall",
            "title": "volumetric painted wood slat wall",
            "src": "/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/968f2/lenticular-painted-wood-slat-wall.jpg",
            "srcSet": ["/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/69549/lenticular-painted-wood-slat-wall.jpg 288w", "/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/473e3/lenticular-painted-wood-slat-wall.jpg 576w", "/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/968f2/lenticular-painted-wood-slat-wall.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">A volumetric pattern wall</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAABKElEQVQ4y+1TvYqDQBj07ewFH8HKxsZCEOQghT8PkGBpJKBCrMTKSrQIQQmIEkgUYq+CiAjRu48s58FhipDyboplvm93dmbZXezzDWB/XTyO4/1+RyMi0zQBmR5AnZedkfipM5ory/J0OuV5nmVZHMdQtm0LpK7rYRiSJLndbvPiHzFEgtGyLIIgNE1jGIamaY7jdrsdSZKqqoZhiOO4aZrodAvO4AN6IIfDwTCM7XYL5o7jrNdrXdc3m03f9wvOqIZ4iqIAd13344Hr9QpBRFGUJEmW5aqqFsQoCZhQFGXbNsgEQVitVuDPsqznecfjkef5/X7/NPblcoGzpWkaRZHv+0VRNE0TBEHXdTALzfP5vOD81lXNi9DDGL8xd1DaX1tg/1/yNXwBSrBtv2vpDZIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM 8-bar logo",
            "title": "IBM 8-bar logo",
            "src": "/workplace-xg/static/02adcd0a53f1e9834166d439764d628f/a5df1/ibm-logo.png",
            "srcSet": ["/workplace-xg/static/02adcd0a53f1e9834166d439764d628f/7fc1e/ibm-logo.png 288w", "/workplace-xg/static/02adcd0a53f1e9834166d439764d628f/a5df1/ibm-logo.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "574px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100.34722222222223%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABYElEQVQ4y42UCavCMBCE8///n/eJVut94GoVy+6bCQYeJW0ifI7SdpudncTNZjNZLBYGVWAx5vO57fd7OxwOSdx4PJbJZGJQBdZkNBrZdDq14/Fol8vFzudzJw5vFlaGKlfRZLfbeb1er3a73ZK4oihku90aVIHFKMvSPp+P1XVt3++3Eyf4vF4vgyiwNqqqyiJZ8Pl8es1p17cMb4Q/oEqfYnAYwc8UDquT9/ttUOVKm7ANrvJ0OvlJp8jykAVD8aCtHuJLOEGodt3Iojk4+CM/n5RexWBgs1terVbCrEEVWBvL5dK4RVNkbT1e32w2PuDcBNQA//8ney/f73c/oMfj0YkbDAYyHA4NqsCa9Pt9X5iGc3iMWBduvV4L24EqsBi8zoIhNl04pNufNlCNJZ87hF7RcJ6LyaHkxIZxYPu9Xi+Jw83CnEE1lquQv9hZGcPhAfkFV/lwk1C07eBo8gcAKNpgp0GZzgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "linear pattern example",
            "title": "linear pattern example",
            "src": "/workplace-xg/static/02329d3d5bc0bdb16c1d6c1ddf212f32/9f151/linear-pattern-example.png",
            "srcSet": ["/workplace-xg/static/02329d3d5bc0bdb16c1d6c1ddf212f32/7fc1e/linear-pattern-example.png 288w", "/workplace-xg/static/02329d3d5bc0bdb16c1d6c1ddf212f32/9f151/linear-pattern-example.png 574w"],
            "sizes": "(max-width: 574px) 100vw, 574px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHprSGgwuGwP//EABgQAAMBAQAAAAAAAAAAAAAAAAABEBEx/9oACAEBAAEFArglV0//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAWEAADAAAAAAAAAAAAAAAAAAAQIEH/2gAIAQEABj8CEf8A/8QAGxAAAwACAwAAAAAAAAAAAAAAAAEREDEhYXH/2gAIAQEAAT8hoto4ECKTt40k9P/aAAwDAQACAAMAAAAQUAg8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhAAAwABBAMAAAAAAAAAAAAAAAERITFBgZFRcfD/2gAIAQEAAT8QQZQcmybiL5dGe0gy8H0Qm5yPieUJZr2P/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood slat wall detail view",
            "title": "wood slat wall detail view",
            "src": "/workplace-xg/static/01aff8e0828e98703d87db471e9f44a1/473e3/close-up-view-of-slat-wall.jpg",
            "srcSet": ["/workplace-xg/static/01aff8e0828e98703d87db471e9f44a1/69549/close-up-view-of-slat-wall.jpg 288w", "/workplace-xg/static/01aff8e0828e98703d87db471e9f44a1/473e3/close-up-view-of-slat-wall.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </ImageCollection>
    <h2>{`Pattern and the 2x Grid`}</h2>
    <p>{`The IBM 2x Grid is the framework for all the visual design at IBM. No matter what medium or application you’re working within, the 2x Grid provides structure and guidance for the execution of any creative concept. Each pattern concept should use the 2x Grid as a foundation.`}</p>
    <h3>{`Divisions of two`}</h3>
    <p>{`At the core of the 2x Grid concept is the idea of divisions of two. This concept can be applied to most surfaces, 3D objects, and architecture to create proportional relationships between various elements. Dividing a space into 2, 4, 8, 16, 32, or 64 columns provides ample flexibility to meet the needs of different use cases.`}</p>
    <h3>{`Base unit`}</h3>
    <p>{`Base units establish precision and proportional relationships for each element in the design. A base unit creates a relationship between grid proportions, dimensions of shapes and space between elements. The size of this base unit is flexible, providing versatility in design execution across a range of environments.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <img {...{
            "src": "/workplace-xg/f747828445058f14bb09399def508e24/pattern-and-2x-grid-mobile.svg",
            "alt": "sketch of how the 2x Grid builds out in units of 2",
            "title": "sketch of how the 2x Grid builds out in units of 2"
          }}></img>
          <img {...{
            "src": "/workplace-xg/4050aa39f1f2ed5ce723d1f62dac1524/pattern-and-2x-grid-desktop.svg",
            "alt": "sketch of how the 2x Grid builds out in units of 2",
            "title": "sketch of how the 2x Grid builds out in units of 2"
          }}></img>
        </ArtDirection>
      </Column>
    </Row>
    <h2>{`Pattern layouts and repeats`}</h2>
    <p>{`Use 2x Grid math—halving and doubling—and simple geometries as you create a pattern to fit a project’s needs. Limit the number of variables to build rhythm and harmony. For example, keep all slats or cuts to a unified, even width and on grid.`}</p>
    <p>{`The 2x Grid framework also makes it easy to create patterns that seamlessly repeat. For example, you can repeat a square pattern twice to fill the grid. Use your base unit to establish comfortable margins in cases where they’re needed, such as when laser-cutting a pattern out of a substrate. The examples shown here demonstrate how to use the 2x Grid to build dynamic linear patterns.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <GifPlayer className="video-player" color="dark" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/c1b89430f0044604aaf9d87ee3b8a3d9/pattern.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsSAAALEgHS3X78AAABC0lEQVQoz6WQ65KDIAyF+/6PuVXp1lXkFki4dANorX93mXjm5MiXzHB7/ePc+CulEOYUc6TUtPpElyTubY4tLOWAc8oIlIgIQubbgRJS9MieNWHkJAZMFPsvBEy5HHAuta+wzxQrQAzzoEg+dN/gPgKRd+TXCYP1EREdKwULPD44YI8OmAnO8xQKFeNr3ObyATvjAnhvq4KxAcBX3RNvXDMQmoJx52Z+MKOMM8bpXa3W7p1wy763e2gvsFy2bVlrrVL+rHJZum8hJ4ucl6Nd1bp9wLk8xfwYp1qTEPdxuo+PgX1PJjEM09fA/nsUYpxm8bxs1srpzdRSVkmjdm96qKTmerdG2fPB/nx+AUeTfyyXzu9GAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animated series of patterns sketches on the 2x Grid",
              "title": "animated series of patterns sketches on the 2x Grid",
              "src": "/workplace-xg/static/da2667cb458918185fcd3cb8f4dcdfa6/3cbba/slat-wall-pattern-blueprint.png",
              "srcSet": ["/workplace-xg/static/da2667cb458918185fcd3cb8f4dcdfa6/7fc1e/slat-wall-pattern-blueprint.png 288w", "/workplace-xg/static/da2667cb458918185fcd3cb8f4dcdfa6/a5df1/slat-wall-pattern-blueprint.png 576w", "/workplace-xg/static/da2667cb458918185fcd3cb8f4dcdfa6/3cbba/slat-wall-pattern-blueprint.png 1152w", "/workplace-xg/static/da2667cb458918185fcd3cb8f4dcdfa6/0b124/slat-wall-pattern-blueprint.png 1728w", "/workplace-xg/static/da2667cb458918185fcd3cb8f4dcdfa6/0c3f5/slat-wall-pattern-blueprint.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
    </Row>
    <h2>{`Pattern form`}</h2>
    <p>{`Linear patterns can be dimensionally executed in a variety of ways. These executions include ceiling designs, millwork walls, screen partitions or flooring. We encourage design teams to explore unexpected or innovative pattern applications.`}</p>
    <Row className="mt-32" mdxType="Row">
      <Column colLg={8} colMd={5} mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/555f412681ba04fd35cdde9e436434d5/slats.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAZTCeSsTQ//EABoQAAICAwAAAAAAAAAAAAAAAAABAgMQEhP/2gAIAQEAAQUC2I3HVDz/AP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAACD/2gAIAQEABj8CX//EABwQAAICAgMAAAAAAAAAAAAAAAERABAhQXHR8P/aAAgBAQABPyFnkuAHue47dBX/2gAMAwEAAgADAAAAEJDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAAEEAwAAAAAAAAAAAAAAAQAQESExYaGx/9oACAEBAAE/EHMfgsAREw9ggyLtHgUbQW0//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animated gallery of slat wall examples",
              "title": "animated gallery of slat wall examples",
              "src": "/workplace-xg/static/754d82c39cfa626160b56c9177e341b1/2e753/close-up-of-painted-wood-slat-wall.jpg",
              "srcSet": ["/workplace-xg/static/754d82c39cfa626160b56c9177e341b1/69549/close-up-of-painted-wood-slat-wall.jpg 288w", "/workplace-xg/static/754d82c39cfa626160b56c9177e341b1/473e3/close-up-of-painted-wood-slat-wall.jpg 576w", "/workplace-xg/static/754d82c39cfa626160b56c9177e341b1/2e753/close-up-of-painted-wood-slat-wall.jpg 1152w", "/workplace-xg/static/754d82c39cfa626160b56c9177e341b1/a052a/close-up-of-painted-wood-slat-wall.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
      <Column colLg={3} colMd={2} offsetMd={1} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
  <strong>Slats</strong><br />Adhere cut pieces to a backing substrate.
  </Aside>
      </Column>
    </Row>
    <Row className="mt-32" mdxType="Row">
      <Column colLg={8} colMd={5} mdxType="Column">
        <GifPlayer className="video-player" color="dark" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/97c22ad743404276c05c69f60c792e40/volumetric.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBBAUG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABuZnSrRhIP//EABwQAAEDBQAAAAAAAAAAAAAAAAEAAgMEEBETFP/aAAgBAQABBQKqmdEeuXKIBWtlv//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAAHAQEAAAAAAAAAAAAAAAABAhAhMpEREv/aAAgBAQAGPwJPnkixY0kKJxv/xAAcEAACAgIDAAAAAAAAAAAAAAAAARExECFxkaH/2gAIAQEAAT8hX0EHaHreAgoB8ob76GP/2gAMAwEAAgADAAAAEFDP/8QAFhEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAEDAQE/EFR//8QAFhEBAQEAAAAAAAAAAAAAAAAAEQEQ/9oACAECAQE/EGAZ/8QAGxABAAICAwAAAAAAAAAAAAAAAQARECFhgdH/2gAIAQEAAT8QSoFOzYx4AWhqFpW9GMTtbz5Y/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animated gallery of volumetric slat wall examples",
              "title": "animated gallery of volumetric slat wall examples",
              "src": "/workplace-xg/static/96d5af04d7cb0994aee42b571dc86201/2e753/volumetric-slat-wall.jpg",
              "srcSet": ["/workplace-xg/static/96d5af04d7cb0994aee42b571dc86201/69549/volumetric-slat-wall.jpg 288w", "/workplace-xg/static/96d5af04d7cb0994aee42b571dc86201/473e3/volumetric-slat-wall.jpg 576w", "/workplace-xg/static/96d5af04d7cb0994aee42b571dc86201/2e753/volumetric-slat-wall.jpg 1152w", "/workplace-xg/static/96d5af04d7cb0994aee42b571dc86201/a052a/volumetric-slat-wall.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
      <Column colLg={3} colMd={2} offsetMd={1} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
  <strong>Volumetric</strong><br />Fins of progressing depths create interesting sculptural walls. 
  </Aside>
      </Column>
    </Row>
    <Row className="mt-32" mdxType="Row">
      <Column colLg={8} colMd={5} mdxType="Column">
        <GifPlayer className="video-player" color="dark" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/bd47be9bd6aa5c5bb227b0b8e7c7e4dd/lenticular.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "896px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABu12o55qJf//EABsQAAICAwEAAAAAAAAAAAAAAAECAAMREiET/9oACAEBAAEFAnIWaCHhehXPliGvv//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAEDAQE/Aaf/xAAWEQEBAQAAAAAAAAAAAAAAAAARARD/2gAIAQIBAT8BoZ//xAAYEAADAQEAAAAAAAAAAAAAAAAAEBExAf/aAAgBAQAGPwI1W9NX/8QAGRABAQEBAQEAAAAAAAAAAAAAAQARMVFh/9oACAEBAAE/IWMewxsOhauD8jLtvRf/2gAMAwEAAgADAAAAEBPP/8QAFxEAAwEAAAAAAAAAAAAAAAAAARAhMf/aAAgBAwEBPxAVcX//xAAXEQADAQAAAAAAAAAAAAAAAAAQESEx/9oACAECAQE/EIlo/8QAGRABAQEBAQEAAAAAAAAAAAAAAREAIUFR/9oACAEBAAE/EAtleGZpkLwwiKh93KrBETE4GSdN2ULv/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animated gallery of lenticular slat wall examples",
              "title": "animated gallery of lenticular slat wall examples",
              "src": "/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/968f2/lenticular-painted-wood-slat-wall.jpg",
              "srcSet": ["/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/69549/lenticular-painted-wood-slat-wall.jpg 288w", "/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/473e3/lenticular-painted-wood-slat-wall.jpg 576w", "/workplace-xg/static/285f9a3bdcd5f046f983dadf8ac2c0ef/968f2/lenticular-painted-wood-slat-wall.jpg 896w"],
              "sizes": "(max-width: 896px) 100vw, 896px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
      <Column colLg={3} colMd={2} offsetMd={1} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
  <strong>Lenticular</strong><br />Evenly spaced blades can create an effect where the piece seems to change as you move past or around it.
  </Aside>
      </Column>
    </Row>
    <Row className="mt-32" mdxType="Row">
      <Column colLg={8} colMd={5} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAQACBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB6DlzSY//xAAVEAEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAQABBQIr/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGBABAQADAAAAAAAAAAAAAAAAAAEQMUH/2gAIAQEAAT8hhrEXiv/aAAwDAQACAAMAAAAQ5x//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAbEAEAAwEAAwAAAAAAAAAAAAABABEhYTGR8P/aAAgBAQABPxCkObGj4u9jS6/eo9TtRtQAcn//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "slat wall with cut out variation",
            "title": "slat wall with cut out variation",
            "src": "/workplace-xg/static/f25af609a8ca0899339897d60f05f577/2e753/slat-wall-with-cut-out-variation.jpg",
            "srcSet": ["/workplace-xg/static/f25af609a8ca0899339897d60f05f577/69549/slat-wall-with-cut-out-variation.jpg 288w", "/workplace-xg/static/f25af609a8ca0899339897d60f05f577/473e3/slat-wall-with-cut-out-variation.jpg 576w", "/workplace-xg/static/f25af609a8ca0899339897d60f05f577/2e753/slat-wall-with-cut-out-variation.jpg 1152w", "/workplace-xg/static/f25af609a8ca0899339897d60f05f577/a052a/slat-wall-with-cut-out-variation.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={3} colMd={2} offsetMd={1} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
  <strong>Cutout</strong><br />Reversing or cutting out a linear pattern from a substrate is a method that’s great for punched-metal ceilings or wooden structures with recessed lighting.
  </Aside>
      </Column>
    </Row>
    <h2>{`Materiality`}</h2>
    <p>{`Linear patterns lend themselves nicely to dimensional executions in a variety of substrates and finishes. Here are a few preliminary studies and examples to consider.`}</p>
    <h3>{`Wood`}</h3>
    <p>{`Wood is a forgiving material and a wonderful way to add warmth to a space. Tone-on-tone executions create subdued dimension. You can introduce different stains or materials to produce additional depth.`}</p>
    <h3>{`Metal`}</h3>
    <p>{`Machine-precision metal complements strong textures and organic materials. Consider anodized metal for a lustrous finish. Powder-coated metal is a more budget-friendly option.`}</p>
    <h3>{`Acrylic`}</h3>
    <p>{`The colors and transparency options of acrylic make it a great choice for areas filled with light. Play with layering. Consider how colorful shadows will change the experience throughout the day.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      